import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'

import { MemberPickerNotFoundText, MEMBERS_PICKER_TRANSLATION_KEYS } from 'features/memberships_picker'

import { GroupsSlugConflict } from './groups_slug_conflict'
import { SelectedGroups } from './selected_groups'
import { SlugConflictNotification } from '../../slug_conflict'


const AddMemberLink = ({ children }) => {
  const inviteUrl = '/app/admin/invitations/new'

  return (
    <Link href={inviteUrl} target="_blank" rel="opener">{children}</Link>
  )
}

const peoplePickerConfiguration = ({ slug }) => ({
  entities: ['memberships', 'invitations'],
  title: I18n.t('publisher.organization.managed_event_types.assign.add_members.title'),
  description: I18n.t('publisher.organization.managed_event_types.assign.add_members.instructions'),
  placeholder: I18n.t('publisher.organization.managed_event_types.assign.add_members.placeholder'),
  notFoundPlaceholderTitle: null,
  notFoundPlaceholderText: (
    <MemberPickerNotFoundText
      scope={MEMBERS_PICKER_TRANSLATION_KEYS.MANAGED_EVENT_TYPES}
      invitationLink={AddMemberLink}
    />
  ),
  slugConflictsPopupTitle: I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.title', { slug }),
  slugConflictsPopupSubmitButtonText: I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.confirm'),
  slugConflictsPopupCancelButtonText: I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.cancel'),
  slugConflictsPopupContent: SlugConflictNotification,
})

const groupsPickerConfiguration = ({ slug }) => ({
  entities: ['userGroups'],
  title: I18n.t('publisher.organization.managed_event_types.assign.add_groups.title'),
  description: I18n.t('publisher.organization.managed_event_types.assign.add_groups.instructions'),
  placeholder: I18n.t('publisher.organization.managed_event_types.assign.add_groups.placeholder'),
  notFoundPlaceholderTitle: I18n.t('publisher.organization.managed_event_types.assign.add_groups.not_found_title'),
  notFoundPlaceholderText: I18n.t('publisher.organization.managed_event_types.assign.add_groups.not_found_description'),
  selectedSuggestionsComponent: SelectedGroups,
  slugConflictsPopupTitle: I18n.t('publisher.organization.managed_event_types.assign.groups_slug_conflict.title', { slug }),
  slugConflictsPopupSubmitButtonText: I18n.t('publisher.organization.managed_event_types.assign.groups_slug_conflict.confirm'),
  slugConflictsPopupCancelButtonText: I18n.t('publisher.action.cancel'),
  slugConflictsPopupContent: GroupsSlugConflict,
})

export const getMembershipsPickerConfiguration = (scope, managedEventType) => {
  switch (scope) {
    case 'groups':
      return groupsPickerConfiguration(managedEventType)
    case 'people':
    default:
      return peoplePickerConfiguration(managedEventType)
  }
}
